/** Disappearing messages — local expiry; recipients may retain copies (SPEC honesty). */

export type DisappearTimerSec = 0 | 30 | 300 | 3600 | 86400 | 604800;

export const DISAPPEAR_OPTIONS: { sec: DisappearTimerSec; label: string }[] = [
  { sec: 0, label: "Off" },
  { sec: 30, label: "30 seconds" },
  { sec: 300, label: "5 minutes" },
  { sec: 3600, label: "1 hour" },
  { sec: 86400, label: "24 hours" },
  { sec: 604800, label: "7 days" },
];

export function expireAt(createdAt: number, timerSec: DisappearTimerSec): number | undefined {
  if (!timerSec) return undefined;
  return createdAt + timerSec * 1000;
}

export function isExpired(expiresAt: number | undefined, now = Date.now()): boolean {
  return typeof expiresAt === "number" && expiresAt <= now;
}

export function filterExpired<T extends { expiresAt?: number; deletedForMe?: boolean }>(
  items: T[],
  now = Date.now(),
): T[] {
  return items.map((m) =>
    isExpired(m.expiresAt, now) ? { ...m, deletedForMe: true, body: "" as never } : m,
  );
}
